import React from 'react';
import image140 from '../../assets/images/workers-examining-work.jpg';
import image180 from '../../assets/images/industry-construction-equipments-inside-storehouse-factory.jpg';
import image190 from '../../assets/images/logistic-center-with-desk-chairs (1).jpg';
import image200 from '../../assets/images/warehouse-storage-interior-with-shelves-loaded-with-goods.jpg';
import image201 from '../../assets/images/design.jpg';
import image202 from '../../assets/images/iron-steel-material-storage.jpg';
import image203 from '../../assets/images/view-geometric-buildings.jpg';
import image204 from '../../assets/images/road-forest.jpg';
import image205 from '../../assets/images/low-angle-view-scafolding-building.jpg';
import image206 from '../../assets/images/pexels-hngstrm-2186572.jpg';
import image207 from '../../assets/images/pexels-pixabay-265087.jpg';
import image208 from '../../assets/images/construction-equipment.webp';

const services = [
  {
    title: 'Engineered Constructions',
    description:
      'Tailored structural solutions for industrial, commercial, and residential projects with precision and innovation.',
    image: image140,
  },
  {
    title: 'Modular Fabrication',
    description:
      'Fast-track your projects with customizable, pre-engineered building components built for durability and flexibility.',
    image: image180,
  },
  {
    title: 'Containerized Structures',
    description:
      'Portable and scalable container buildings ideal for offices, homes, and mobile infrastructure setups.',
    image: image190,
  },
  {
    title: 'Bulk Material Storage Terminals',
    description:
      'Secure storage facilities designed for handling and storing large quantities of raw materials efficiently.',
    image: image200,
  },
  {
    title: 'Design & Execution Services',
    description:
      'End-to-end project planning and implementation with architectural excellence and on-site execution.',
    image: image201,
  },
  {
    title: 'Factory Infrastructure Development',
    description:
      'Comprehensive development of industrial facilities with smart layouts and robust engineering.',
    image: image202,
  },
  {
    title: 'Hospital & Hotel Constructions',
    description:
      'Specialized construction services for hospitality and healthcare with comfort, compliance, and modern design.',
    image: image203,
  },
  {
    title: 'Roadway & Transportation Projects',
    description:
      'Infrastructure development for highways, bridges, and public transit systems with lasting impact.',
    image: image204,
  },
  {
    title: 'Turnkey EPC Solutions',
    description:
      'One-stop solution for Engineering, Procurement, and Construction with assured quality and timely delivery.',
    image: image205,
  },
  {
    title: 'Maintenance Services',
    description:
      'Preventive and corrective maintenance services for infrastructure and equipment to ensure operational continuity.',
    image: image206,
  },
  {
    title: 'Financial Services',
    description:
      'Smart financing and investment support for infrastructure and construction projects.',
    image: image207,
  },
  {
    title: 'Industrial Equipment Solutions',
    description:
      'Supply and integration of high-performance industrial tools and machinery for various applications.',
    image: image208,
  },
];

export const ServicesComponent = () => {
  return (
    <div className="relative w-full max-w-[100vw] mx-auto py-16 px-4 sm:px-6 lg:px-12 2xl:px-24 bg-white flex items-center justify-center">
      <div className="flex flex-col items-center gap-12 w-full">
        {/* Heading Section */}
        <div className="flex flex-col gap-4 w-full max-w-screen-2xl px-4">
          <h2 className="text-[#e6b127] text-center font-semibold text-[clamp(1.2rem,2vw,1.5rem)] leading-[150%]">
            Our Services
          </h2>
          <div className="text-center text-[#404040] font-black text-[clamp(2rem,4vw,2.7rem)] leading-tight">
            Innovative Solutions. Built With Precision
          </div>
        </div>

        {/* Services Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-8 w-full max-w-screen-2xl px-4">
          {services.map((service, index) => (
            <div
              key={index}
              className="w-full h-[480px] 2xl:h-[540px] bg-[#f8f8f8] rounded-2xl shadow-md hover:shadow-[0_0_20px_#87ceeb] transition-all duration-300 overflow-hidden group"
            >
              <div className="w-full h-[200px] 2xl:h-[240px] border-b-4 border-[#5bc0fe]">
                <img
                  src={service.image}
                  alt={service.title}
                  loading="lazy"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6 flex flex-col gap-3">
                <h3 className="text-[#5bc0fe] font-semibold text-[clamp(1.2rem,1.6vw,1.6rem)] leading-tight group-hover:text-[#111]">
                  {service.title}
                </h3>
                <p className="text-[#595959] font-medium text-[clamp(0.9rem,1vw,1.1rem)] leading-[150%]">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesComponent;
